module.exports = __webpack_public_path__ + "img/cp-abundance-2.63359eb4.svg";